"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profiler = exports.NoopProfiler = exports.PerformanceApiProfiler = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Utilities_1 = require("./Utilities");
var PerformanceApiProfiler = /** @class */ (function () {
    function PerformanceApiProfiler(performance) {
        this._performance = performance;
    }
    PerformanceApiProfiler.prototype.measure = function (func, name) {
        this._performance.mark(name + "-begin");
        try {
            return func();
        }
        finally {
            this._performance.mark(name + "-end");
            this._performance.measure("🍆 " + name, name + "-begin", name + "-end");
        }
    };
    PerformanceApiProfiler.prototype.measureAsync = function (func, name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._performance.mark(name + "-begin");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, func()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        this._performance.mark(name + "-end");
                        this._performance.measure("🍆 " + name, name + "-begin", name + "-end");
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return PerformanceApiProfiler;
}());
exports.PerformanceApiProfiler = PerformanceApiProfiler;
var NoopProfiler = /** @class */ (function () {
    function NoopProfiler() {
    }
    NoopProfiler.prototype.measure = function (func, _name) {
        return func();
    };
    NoopProfiler.prototype.measureAsync = function (func, _name) {
        return func();
    };
    return NoopProfiler;
}());
exports.NoopProfiler = NoopProfiler;
// Test environment code:
// BTW: Istanbul is sortof a piece of shit.
/* istanbul ignore next */
exports.profiler = (0, Utilities_1.getEnvironment)().profilingEnabled /* istanbul ignore next */
    ? /* istanbul ignore next */
        /* istanbul ignore next */ new PerformanceApiProfiler(
        /* istanbul ignore next */ global.nodePerf || /* istanbul ignore next */ global.performance)
    : /* istanbul ignore next */ new NoopProfiler();
//# sourceMappingURL=Profiler.js.map